import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { Flex } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/tag";
import { AcordoStatus } from "core/features/acordo/enums";
import { AcordoItem } from "core/features/acordo/typings";
import moment from "moment";
import { useMemo } from "react";

function useAcordoCardColumns() {

  return useMemo(() => {
    const getStatusColor = (item: AcordoItem) => {
      if (item.diasEmAtraso > 0 && item.status !== AcordoStatus.Pago) {
        return "red";
      }
      if (item.status === AcordoStatus.Pago) {
        return "green";
      }
      if (item.status === AcordoStatus.Renegociado) {
        return "gray"
      }
      return "yellow";
    };

    const getStatusText = (item: AcordoItem) => {
      if (item.diasEmAtraso > 0 && item.status !== AcordoStatus.Pago) {
        return "Em atraso";
      }
      if (item.status === AcordoStatus.Pago) {
        return "Pago";
      }
      if (item.status === AcordoStatus.Renegociado) {
        return "Renegociado";
      }
      return "Pendente";
    };

    return [
      {
        title: "Data",
        dataIndex: "dataPagamento",
        render: (data: string) => {
          return <Flex>{data ? moment(data).format("DD/MM/YYYY") : "--"}</Flex>;
        },
      },
      {
        title: "Valor",
        dataIndex: "valor",
        render: (valor: number) => {
          return <Flex>R${formatCurrency(valor)}</Flex>;
        },
      },
      {
        title: "Situação",
        render: (original: AcordoItem) => {
          return (
            <Flex>
              <Tag
                variant="outline"
                colorScheme={getStatusColor(original)
                }
                size="sm"
              >
                {getStatusText(original)}
              </Tag>
            </Flex>
          );
        },
      },
    ];
  }, []);
}

export default useAcordoCardColumns;
